import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { ArrowUpIcon, ArrowDownIcon, ArrowsVerticalIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default, { useState, useContext, useEffect } from 'react';
import { TableContext } from './TableSimple.js';

var _excluded = ["as", "align", "className", "children", "context", "xs", "sm", "md", "lg", "xl", "id", "justify", "sortable", "sortType", "defaultSort"];

/* eslint-disable sort-keys */
var TableHeader = function TableHeader(_ref) {
  var _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'th' : _ref$as;
    _ref.align;
    var className = _ref.className,
    children = _ref.children;
    _ref.context;
    var xs = _ref.xs,
    sm = _ref.sm,
    md = _ref.md,
    lg = _ref.lg,
    xl = _ref.xl,
    id = _ref.id,
    justify = _ref.justify,
    sortable = _ref.sortable,
    _ref$sortType = _ref.sortType,
    sortType = _ref$sortType === void 0 ? 'character' : _ref$sortType,
    defaultSort = _ref.defaultSort,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState('none'),
    _useState2 = _slicedToArray(_useState, 2),
    sort = _useState2[0],
    setSort = _useState2[1];
  var _useState3 = useState('none'),
    _useState4 = _slicedToArray(_useState3, 2),
    sortText = _useState4[0],
    setSortText = _useState4[1];
  var parentProps = useContext(TableContext);
  var columnIndex = otherProps['data-column-index'];
  useEffect(function () {
    // if a different column is sorted, remove sort from other columns
    if (parentProps.sortColumnIndex !== columnIndex) {
      setSort('none');
      setSortText('none');
    }
  }, [id, columnIndex, parentProps.sortColumnIndex, sort]);
  useEffect(function () {
    var defaultSortingOptions = ['ascending', 'descending'];
    if (defaultSortingOptions.includes(defaultSort) && parentProps.sortColumnIndex === null) {
      switch (defaultSort) {
        case 'ascending':
          setSort('asc');
          setSortText('sorted ascending');
          parentProps.onSort(undefined, 'asc', columnIndex, sortType);
          break;
        case 'descending':
          setSort('dsc');
          setSortText('sorted descending');
          parentProps.onSort(undefined, 'dsc', columnIndex, sortType);
          break;
      }
    }
  }, [columnIndex, defaultSort, parentProps, sortType]);
  var handleSortChange = function handleSortChange(event) {
    switch (sort) {
      case 'asc':
        setSort('dsc');
        setSortText('descending');
        parentProps.onSort(event, 'dsc', columnIndex, sortType);
        break;
      case 'dsc':
        setSort('none');
        setSortText('none');
        parentProps.onSort(event, 'none', columnIndex, sortType);
        break;
      case 'none':
        setSort('asc');
        setSortText('ascending');
        parentProps.onSort(event, 'asc', columnIndex, sortType);
        break;
    }
  };
  var finalClasses = classnames('C-TableHeader', _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    '--xs-size-auto': xs === true
  }, "--xs-size-".concat(xs), xs && xs !== true), '--sm-size-auto', sm === true), "--sm-size-".concat(sm), sm && sm !== true), '--md-size-auto', md === true), "--md-size-".concat(md), md && md !== true), '--lg-size-auto', lg === true), "--lg-size-".concat(lg), lg && lg !== true), '--xl-size-auto', xl === true), "--xl-size-".concat(xl), xl && xl !== true), "--justify-".concat(justify), justify), className);
  var finalSortIconClasses = classnames('C-TableHeader__SortIndicator', _defineProperty({}, "--sort-".concat(sort), sort));
  var finalSortButtonClasses = classnames('C-TableHeader__SortButton', _defineProperty({}, "--justify-".concat(justify), justify), className);
  if (sortable) {
    return /*#__PURE__*/React__default.createElement(As, {
      scope: "col",
      "aria-sort": sortText,
      "aria-colindex": columnIndex,
      className: finalClasses
    }, /*#__PURE__*/React__default.createElement("button", _extends({
      type: "button",
      className: finalSortButtonClasses,
      onClick: handleSortChange
    }, otherProps), /*#__PURE__*/React__default.createElement("span", {
      className: "C-TableHeader__innerContent",
      tabIndex: "-1"
    }, children, sort === 'asc' ? /*#__PURE__*/React__default.createElement("span", {
      className: finalSortIconClasses,
      "aria-hidden": "true"
    }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
      className: "C-TableHeader__SortIndicator__Icon",
      size: "inline",
      icon: ArrowUpIcon
    })) : sort === 'dsc' ? /*#__PURE__*/React__default.createElement("span", {
      className: finalSortIconClasses,
      "aria-hidden": "true"
    }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
      className: "C-TableHeader__SortIndicator__Icon",
      size: "inline",
      icon: ArrowDownIcon
    })) : /*#__PURE__*/React__default.createElement("span", {
      className: finalSortIconClasses,
      "aria-hidden": "true"
    }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
      className: "C-TableHeader__SortIndicator__Icon",
      size: "inline",
      icon: ArrowsVerticalIcon
    })))));
  } else {
    return /*#__PURE__*/React__default.createElement(As, _extends({
      "aria-colindex": columnIndex,
      scope: "col",
      className: finalClasses
    }, otherProps), /*#__PURE__*/React__default.createElement("span", {
      className: "C-TableHeader__innerContent",
      tabIndex: "-1"
    }, children));
  }
};
TableHeader.displayName = 'Table.Header';

export { TableHeader as default };
